import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { call, countryArr, eyeClose, eyeOpen } from "../../assets/img";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { post, put } from "../../Services/ApiHandler";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import countryData from "../../Services/CountryData.json";
import SubmitButton from "../../Component/SubmitButton";
import CommonPopup from "../../Component/CommonPopup";
import { MaskIcon } from "../../Component/MaskIcon";
import { PRIMARY_COLOR } from "../../Services/Colors";

const ClientAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const type = location?.state?.type || "add";
  const data = location?.state?.data || null;

  const [formData, setFormData] = useState({
    Name: "",
    mobile: "",
    Password: "",
  });

  const [errors, setErrors] = useState({});
  const [popup, setPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [isValidForm, setIsValidForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryData.find((c) => c.iso === "IN") || countryData[0]
  );

  const maxLength = selectedCountry?.maxLength;

  // Pre-fill for edit mode
  useEffect(() => {
    if (type === "edit" && data) {
      setFormData({
        Name: data?.name || "",
        mobile: data?.mobile || "",
        Password: "",
      });
      setCountryCode(data?.country_code || "+91");
    }
  }, [type, data]);

  const validatePhone = (value, code = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, code);
    return phoneNumber ? phoneNumber.isValid() : false;
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (value.length <= maxLength) {
      setFormData((prev) => ({ ...prev, mobile: value }));
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }
  };

  const handleCountrySelect = (country) => {
    setFormData((prev) => ({ ...prev, mobile: "" }));
    setSelectedCountry(country);
    setCountryCode(country.code);
    setDropdownOpen(false);
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.Name.trim()) newErrors.Name = "Name is required";
    else if (formData.Name.length < 3) newErrors.Name = "Name must be at least 3 characters";
    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    if (type === "add" || formData.Password) {
      if (!formData.Password) newErrors.Password = "Password is required";
      else if (formData.Password.length < 4) newErrors.Password = "Password must be at least 4 characters";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Live form validation
  useEffect(() => {
    const phoneOk = validatePhone(formData.mobile, countryCode) || formData.mobile.length >= 10;
    const nameOk = formData.Name.trim().length >= 3;
    const passOk = type === "edit" ? true : formData.Password.length >= 4;
    setIsValidForm(phoneOk && nameOk && passOk);
  }, [formData, countryCode, type]);

  const handleSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (!validate()) return;

    const cleanMobile = formData.mobile.replace(countryCode, "").replace(/[^\d]/g, "");
    const finalData = {
      name: formData.Name,
      mobile: cleanMobile,
      country_code: countryCode,
      ...(formData.Password && { password: formData.Password }),
    };

    try {
      setIsLoading(true);
      let res;
      if (type === "add") {
        res = await post(URLS.CLIENT, finalData);
      } else {
        res = await put(`${URLS.CLIENT}/${data?.id}`, finalData);
      }
      setPopup(false);
      navigate("/client-list", { replace: true });
    } catch (error) {
      console.error("Error saving client:", error);
    } finally {
      setIsLoading(false);
      setPopup(false);
    }
  };

  return (
    <div className="dashRightView">
      <div style={{ paddingTop: 0 }} className="container_overall col-md-5">
        <p className="f3 admin_title fs-sm-15 fs-md-16 fs-lg-18 fs-xl-19 fs-xxl-21 my-3">
          {type === "add" ? "Add New Client" : "Edit Client"}
        </p>

        {/* Name */}
        <div className="col-md-5" style={{ marginBottom: 20 }}>
          <label className="form-label f3 primary mb-0">Name</label>
          <input
            className="input-box f3 fs-md-14 fs-lg-16 placholdercolorchanges2"
            name="Name"
            value={formData.Name}
            onChange={(e) => setFormData((prev) => ({ ...prev, Name: e.target.value }))}
            maxLength={60}
            type="text"
            placeholder="Enter client name"
            required
          />
          {errors.Name && <p className="err">{errors.Name}</p>}
        </div>

        {/* Mobile */}
        <div className="form-group text-start col-md-5">
          <label className="form-label f3 mb-0 primary">Mobile Number</label>
          <div
            className="login-input mt-1"
            style={{ height: 50, background: "#F0EDE6", display: "flex", alignItems: "center", borderRadius: 8, position: "relative" }}
          >
            <button
              type="button"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              style={{ backgroundColor: "#6E6E6E", border: `1px solid ${PRIMARY_COLOR}`, color: "#ffffff", fontSize: 16, width: 60, height: 50, display: "flex", alignItems: "center", justifyContent: "center", gap: 4, cursor: "pointer", borderRadius: "8px 0 0 8px", position: "relative", padding: "0 34px" }}
            >
              <img src={countryArr} alt="country dropdown arrow" style={{ width: 15, height: 9 }} />
              {selectedCountry.code}
            </button>

            <input
              type="number"
              placeholder="Mobile Number"
              className="placholdercolorchanges2"
              value={formData.mobile}
              onChange={handleMobileChange}
              style={{ flex: 1, border: "none", outline: "none", backgroundColor: "transparent", fontSize: 16, color: "#1B1B1B", padding: "0 10px", height: 51 }}
            />

            <MaskIcon src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: "relative"}} />

            {dropdownOpen && (
              <div style={{ position: "absolute", top: 52, left: 0, right: 0, backgroundColor: "#ffffff", border: "1px solid rgb(0 71 67 / 40%)", borderRadius: 8, maxHeight: 200, overflowY: "auto", zIndex: 1000 }}>
                {countryData.map((country) => (
                  <div
                    key={country.iso}
                    onClick={() => handleCountrySelect(country)}
                    style={{ padding: "10px", cursor: "pointer", borderBottom: "1px solid rgb(0 71 67 / 40%)", backgroundColor: selectedCountry.iso === country.iso ? "#ffffff" : "#F0EDE6" }}
                  >
                    {country.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          {errors.mobile && <p className="err">{errors.mobile}</p>}
        </div>

        {/* Password */}
        <div className="form-group text-start mt-4 col-md-5">
          <label className="form-label f3 mb-0 primary">Password</label>
          <div className="login-input1 mt-1" style={{ display: "flex" }}>
            <input
              className="fs-md-14 f3 fs-lg-16 flex-grow-1 placholdercolorchanges2"
              name="Password"
              value={formData.Password}
              onChange={(e) => setFormData((prev) => ({ ...prev, Password: e.target.value }))}
              type={showPassword ? "text" : "password"}
              placeholder="Enter client password"
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              style={{ cursor: "pointer", top: 1, position: "relative" , right : "12px"}}
              className="password_color"
            >
              {showPassword
                ? <MaskIcon src={eyeOpen} className="imageOpen" alt="" />
                : <MaskIcon src={eyeClose} className="imageClose" alt="" />}
            </span>
          </div>
          {errors.Password && <p className="err">{errors.Password}</p>}
        </div>

        {/* Submit */}
        <div className="my-5">
          <SubmitButton
            onClick={() => setPopup(true)}
            title={type === "add" ? "Add Client" : "Update Client"}
            disabled={!isValidForm || isLoading}
            isFormValid={!isValidForm}
            loading={isLoading}
            width={true}
          />
        </div>
      </div>

      <CommonPopup
        isOpen={popup}
        message={`Are you sure you want to ${type === "add" ? "Add" : "Update"} this client?`}
        onClose={() => setPopup(false)}
        onConfirm={handleSubmit}
        loading={isLoading}
      />
    </div>
  );
};

export default ClientAdd;
